import { AlertCircle, CheckCircle2, Info } from 'lucide-react';
import { useToastStore } from '@/stores/toastStore';

const ICONS = { info: Info, success: CheckCircle2, error: AlertCircle } as const;
const TONES = {
  info: 'bg-charcoal-900 text-white',
  success: 'bg-emerald-600 text-white',
  error: 'bg-red-600 text-white',
} as const;

export function ToastViewport() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex flex-col items-center gap-2 px-4" role="status" aria-live="polite">
      {toasts.map((t) => {
        const Icon = ICONS[t.tone];
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => dismiss(t.id)}
            className={`pointer-events-auto flex max-w-md items-center gap-2 rounded-full px-4 py-2.5 text-sm font-medium shadow-lg animate-fade-up ${TONES[t.tone]}`}
          >
            <Icon size={16} aria-hidden="true" />
            <span>{t.text}</span>
          </button>
        );
      })}
    </div>
  );
}
